import { render, staticRenderFns } from "./DealerSelect.vue?vue&type=template&id=8bd55016"
import script from "./DealerSelect.vue?vue&type=script&lang=js"
export * from "./DealerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports